import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h2>TAQNYA FZCO</h2>
            <br/>
            <p>Smart Solutions </p>
            <p>facebook: <a href='https://www.facebook.com/profile.php?id=61566399059163' target="_blank" rel="noopener noreferrer">Taqnya</a></p>
            
          
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/activity">Our Activities</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📍 UAE ,Silicon Oasis ,Digital Park Freezone, DUBAI</p>
            <p>📞563002576 (971+) </p>
            <p>✉️ info.taqnya@gmail.com</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} TAQNYA FZCO. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;